import Datatable from "./datatable_controller";
import { put } from "@rails/request.js";

// Connects to data-controller="discount-datatable"
export default class extends Datatable {

  static values = {
    eventId: String
  }
  connect() {
    super.connect()
  }

  get columns() {
    return [
      {
        data: 'name',
        createdCell: function(td, cellData, rowData, row, col) {
          td.setAttribute('data-label', 'Code Name');
        }
      },
      {
        data: 'discount',
        createdCell: function(td, cellData, rowData, row, col) {
          td.setAttribute('data-label', 'Discount');
        }
      },
      {
        data: 'used',
        createdCell: function(td, cellData, rowData, row, col) {
          td.setAttribute('data-label', 'Used');
        }
      },
      {
        data: 'revenue',
        createdCell: function(td, cellData, rowData, row, col) {
          td.setAttribute('data-label', 'Revenue');
        }
      },
      {
        data: 'status',
        createdCell: function(td, cellData, rowData, row, col) {
          td.setAttribute('data-label', 'Status');
        }
      },
      {
        data: 'expires',
        createdCell: function(td, cellData, rowData, row, col) {
          td.setAttribute('data-label', 'Expires');
        }
      },
      {
        data: 'applies_to',
        createdCell: function(td, cellData, rowData, row, col) {
          td.setAttribute('data-label', 'Applies To');
        }
      },
      {
        data: 'actions',
        createdCell: function(td, cellData, rowData, row, col) {
          td.setAttribute('data-label', 'Actions');
        }
      }
    ]
  }

  get searching() {
    return true
  }

  get ordering() {
    return false
  }

  get lengthChange() {
    return false
  }

  // Flips a code's status from the listing's toggle.
  //
  // The toggle is a plain <div> wired to `click->discount-datatable#toggleSwitch`
  // (see ApplicationDatatable#toggle_button) — deliberately NOT a turbo link, so
  // Turbo Drive's hover prefetch can never fire it. The state only changes on a
  // real click.
  //
  // Overrides the base toggleSwitch to:
  //   a. take the event explicitly instead of reading the global `window.event`
  //   b. ignore clicks while a request is in flight, so a double-click can't
  //      leave the KPI cards out of step with the row
  // The response is a turbo stream that repaints #discount_metrics, keeping
  // "Active Codes" correct without a page reload.
  async toggleSwitch(event) {
    event.preventDefault()

    const switchButton = event.currentTarget
    if (switchButton.dataset.busy === "true") return

    const status = switchButton.dataset.statusValue !== "true"
    switchButton.dataset.busy = "true"

    try {
      const response = await put(switchButton.dataset.urlValue, {
        contentType: "application/json",
        body: { status: status },
        responseKind: "turbo-stream",
      })

      if (response.ok) {
        switchButton.classList.toggle("toggle-btn-on", status)
        switchButton.dataset.statusValue = `${status}`
      }
    } finally {
      delete switchButton.dataset.busy
    }
  }
}
